import React, { useRef } from 'react';
import ContextProvider from 'context/ContextProvider';
import Canvas from 'components/Canvas';
import {
  Toolbar,
  Container,
  Typography,
  createMuiTheme,
  ThemeProvider,
  responsiveFontSizes,
} from '@material-ui/core';
import Controller from 'components/Controller';

function App() {
  let theme = createMuiTheme({
    typography: {
      fontFamily: ['Kanit', 'Roboto', 'sans-serif'].join(','),
    },
  });
  theme = responsiveFontSizes(theme);

  const chartRef = useRef<HTMLDivElement>(null);

  return (
    <div className='App'>
      <ContextProvider>
        <ThemeProvider theme={theme}>
          <Toolbar disableGutters>
            <Container maxWidth='md'>
              <Typography variant='h4' component='h1'>
                สร้างไทม์ไลน์โควิดออนไลน์
              </Typography>
            </Container>
          </Toolbar>

          <Container maxWidth='md'>
            <Canvas chartRef={chartRef} />
            <Controller chartRef={chartRef} />
          </Container>
          <div style={{ height: '100px' }}></div>
        </ThemeProvider>
      </ContextProvider>
    </div>
  );
}

export default App;
